// Module
var code = "<template> <require from=\"resources/pagelayout/viewheader/view-header\"></require> <require from=\"resources/pagelayout/viewheader/view-header-triple-layout\"></require> <view-header> <view-header-triple-layout> <div slot=\"left\" t=\"my_groups\"></div> </view-header-triple-layout> </view-header> </template> ";
// Exports
export default code;